import React from 'react';
import { Layout, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { BarChartOutlined } from '@ant-design/icons';

const { Header, Content, Footer } = Layout;
const { Title } = Typography;

const ReportLayout = ({ children }) => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center', padding: '0 24px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <BarChartOutlined style={{ fontSize: '24px', color: 'white', marginRight: '10px' }} />
          <Title level={3} style={{ color: 'white', margin: 0 }}>
            安全培训考试系统 - 数据报表
          </Title>
        </div>
      </Header>
      <Content style={{ padding: '24px', background: '#f0f2f5' }}>
        {children}
      </Content>
      <Footer style={{ textAlign: 'center' }}>
        安全培训考试系统 ©{new Date().getFullYear()} 版权所有
      </Footer>
    </Layout>
  );
};

export default ReportLayout; 